/**
 * AudioWaveformCanvas Component
 * Presentation component for audio waveform visualization
 * Wraps canvas element with Material-UI Box styling
 */

import { Box, type SxProps, type Theme } from '@mui/material';
import { forwardRef } from 'react';

interface AudioWaveformCanvasProps {
  width?: number;
  height?: number;
  sx?: SxProps<Theme>;
  ariaLabel?: string;
  style?: React.CSSProperties;
}

export const AudioWaveformCanvas = forwardRef<HTMLCanvasElement, AudioWaveformCanvasProps>(function AudioWaveformCanvas(
  { width = 200, height = 40, sx, ariaLabel, style },
  ref
) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
      <canvas
        ref={ref}
        width={width}
        height={height}
        aria-label={ariaLabel}
        style={{
          borderRadius: 4,
          backgroundColor: 'transparent',
          display: 'block',
          width: '100%',
          height: '100%',
          ...style
        }}
      />
    </Box>
  );
});
